import PropTypes from 'prop-types'
import { useState, useEffect, Fragment } from 'react'

import MenuFiltros from '../MenuFiltros'
import Presupuesto from '../presupuestos/Presupuesto'
import ComponenteError from '../publicaciones/ComponenteError'
import * as presupuestosService from '../servicios/presupuestosService'
import BordePrincipal from '../ui/BordePrincipal'

const Presupuestos = () => {
  const [presupuestos, setPresupuestos] = useState([])
  const [sinResultados, setSinResultados] = useState(false)

  const fetchPresupuestos = async () => {
    const { data } = await presupuestosService.buscarPorComprador(
      parseInt(localStorage.getItem('idUsuario'))
    )
    setPresupuestos(data)
    setSinResultados(data.length === 0)
  }

  useEffect(() => {
    fetchPresupuestos()
  }, [])

  return (
    <>
      <MenuFiltros idComponente={45} />
      <BordePrincipal titulo="Mis Presupuestos">
        {!sinResultados ? (
          presupuestos.map((presupuesto) => (
            <Fragment key={presupuesto.idPresupuesto}>
              <Presupuesto presupuesto={presupuesto} canAdministrate={false} />
            </Fragment>
          ))
        ) : (
          <div className="row">
            <ComponenteError tipo="I" idAviso={21} />
          </div>
        )}
      </BordePrincipal>
    </>
  )
}

Presupuestos.propTypes = {
  onToggleClick: PropTypes.func.isRequired
}

export default Presupuestos
